import React, { createContext, useContext, useEffect, useState } from "react";

type NetworkStatusContextType = {
  isOnline: boolean;
};

const NetworkStatusContext = createContext<NetworkStatusContextType>({
  isOnline: true,
});

export const NetworkStatusProvider: React.FC<{ children: React.ReactNode }> = ({ 
  children 
}) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <NetworkStatusContext.Provider value={{ isOnline }}>
      {children}
      {!isOnline && <NetworkStatusBanner />}
    </NetworkStatusContext.Provider>
  );
};

const NetworkStatusBanner = () => (
  <div className="network-status-banner">
    Você está offline - Por favor, verifique sua conexão com a internet.
  </div>
);

export const useNetworkStatus = () => useContext(NetworkStatusContext);